import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  cdRoot: {
    borderRadius: theme.spacing(0.5),
    overflow: "scroll",
    background: "transparent"
  },

  title: {
    width: "100%",
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: "Courier Prime",
    textAlign: "center"
  },

  cdHeader: {
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
    background: theme.palette.background.defaultGradient
  },
  cdAvatar: {
    width: 100,
    height: 100,
    marginRight: theme.spacing(1),
    borderRadius: "50%",
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundImage: ({ campaignDetail }) =>
      campaignDetail && `url(${campaignDetail.image})`,
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    boxShadow: theme.customShadows(theme.palette.primary.main),
    background: "white"
  },

  cdSubscribeContainer: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(0.5),
    color: theme.palette.jamii.brown
  },
  cdSubscribeButton: {
    margin: theme.spacing(0.5)
  }
}));
